import { Box, Container, Stack, useTheme } from "@mui/material";
import { Menu } from "./menu";
import { useScrollDirection } from "../../utilities";
import { useWindowScrollPosition } from "rooks";
import Link from "next/link";
import React from "react";
export const StickyHeader = ({ logo, menuItems = [], }) => {
    const theme = useTheme();
    const scrollDirection = useScrollDirection(50);
    const { scrollY } = useWindowScrollPosition();
    const show = scrollDirection === "up" && scrollY > 768;
    return (React.createElement(Box, { "aria-hidden": !show, sx: {
            backgroundColor: theme.palette.background.default,
            left: 0,
            opacity: show ? 1 : 0,
            position: "fixed",
            top: 0,
            transform: `translateY(${show ? "0" : "-50%"})`,
            transition: theme.transitions.create(["transform", "opacity"]),
            width: "100%",
            zIndex: 60,
        } },
        React.createElement(Container, null,
            React.createElement(Stack, { alignItems: "center", direction: "row", justifyContent: "space-between", sx: { pt: 1, pb: 1 } },
                React.createElement(Box, { sx: { flexGrow: 1, maxWidth: theme.spacing(6), height: "auto" } },
                    React.createElement(Link, { href: "/" }, logo)),
                React.createElement(Menu, { isSticky: true, menuItems: menuItems })))));
};
//# sourceMappingURL=sticky-header.js.map